import routeNames from './route-names'

const ProductInventoryTabs = () => import(/* webpackChunkName: "products" */'@/views/product-inventory/ProductInventoryTabs')

const Products = () => import(/* webpackChunkName: "products" */'@/views/product-inventory/product/Products')
const Product = () => import(/* webpackChunkName: "products" */'@/views/product-inventory/product/Product')
const RemoveProduct = () => import(/* webpackChunkName: "product" */'@/views/product-inventory/product/RemoveProduct')
const ManageProduct = () => import(/* webpackChunkName: "product" */'@/views/product-inventory/product/ManageProduct')

const Suppliers = () => import(/* webpackChunkName: "suppliers" */'@/views/product-inventory/supplier/Suppliers')
const Supplier = () => import(/* webpackChunkName: "suppliers" */'@/views/product-inventory/supplier/Supplier')
const RemoveSupplier = () => import(/* webpackChunkName: "supplier" */'@/views/product-inventory/supplier/RemoveSupplier')
const ManageSupplier = () => import(/* webpackChunkName: "supplier" */'@/views/product-inventory/supplier/ManageSupplier')

const ProductCategories = () => import(/* webpackChunkName: "product-categories" */'@/views/product-inventory/product-category/ProductCategories')
const ProductCategory = () => import(/* webpackChunkName: "product-categories" */'@/views/product-inventory/product-category/ProductCategory')
const RemoveProductCategory = () => import(/* webpackChunkName: "product-category" */'@/views/product-inventory/product-category/RemoveProductCategory')
const ManageProductCategory = () => import(/* webpackChunkName: "product-category" */'@/views/product-inventory/product-category/ManageProductCategory')

const MetricTypes = () => import(/* webpackChunkName: "metric-types" */'@/views/product-inventory/metric-type/MetricTypes')
const MetricType = () => import(/* webpackChunkName: "metric-types" */'@/views/product-inventory/metric-type/MetricType')
const RemoveMetricType = () => import(/* webpackChunkName: "metric-type" */'@/views/product-inventory/metric-type/RemoveMetricType')
const ManageMetricType = () => import(/* webpackChunkName: "metric-type" */'@/views/product-inventory/metric-type/ManageMetricType')

export default {
    path: '/products/inventory',
    alias: '/products',
    component: ProductInventoryTabs,
    children: [
        {
            path: '/',
            name: routeNames.INVENTORY_PRODUCTS,
            meta: {title: 'Products'},
            component: Products,
            children: [
                {
                    path: 'create',
                    name: routeNames.INVENTORY_PRODUCT_CREATE,
                    meta: {title: 'Create Product'},
                    component: ManageProduct
                },
                {
                    path: 'show/:productId',
                    name: routeNames.INVENTORY_PRODUCT,
                    props: (route) => ({
                        productId: parseInt(route.params.productId)
                    }),
                    meta: {title: 'Product Details'},
                    component: Product
                },
                {
                    path: 'update/:productId',
                    name: routeNames.INVENTORY_PRODUCT_UPDATE,
                    props: (route) => ({
                        productId: parseInt(route.params.productId)
                    }),
                    meta: {title: 'Update Product'},
                    component: ManageProduct
                },
                {
                    path: 'remove/:productId',
                    name: routeNames.INVENTORY_PRODUCTS_REMOVE,
                    props: (route) => ({
                        productId: parseInt(route.params.productId)
                    }),
                    meta: {title: 'Remove Product'},
                    component: RemoveProduct
                }
            ]
        },
        {
            path: 'suppliers',
            name: routeNames.INVENTORY_SUPPLIERS,
            props: true,
            meta: {title: 'Suppliers'},
            component: Suppliers,
            children: [
                {
                    path: 'create',
                    name: routeNames.INVENTORY_SUPPLIER_CREATE,
                    meta: {title: 'Create Supplier'},
                    component: ManageSupplier
                },
                {
                    path: ':supplierId',
                    name: routeNames.INVENTORY_SUPPLIER,
                    props: (route) => ({
                        supplierId: parseInt(route.params.supplierId)
                    }),
                    meta: {title: 'Supplier Details'},
                    component: Supplier
                },
                {
                    path: 'update/:supplierId',
                    name: routeNames.INVENTORY_SUPPLIER_UPDATE,
                    props: (route) => ({
                        supplierId: parseInt(route.params.supplierId)
                    }),
                    meta: {title: 'Update Supplier'},
                    component: ManageSupplier
                },
                {
                    path: 'remove/:supplierId',
                    name: routeNames.INVENTORY_SUPPLIERS_REMOVE,
                    props: (route) => ({
                        supplierId: parseInt(route.params.supplierId)
                    }),
                    meta: {title: 'Remove Supplier'},
                    component: RemoveSupplier
                }
            ]
        },
        {
            path: 'product-categories',
            name: routeNames.INVENTORY_PRODUCT_CATEGORIES,
            props: true,
            meta: {title: 'Categories'},
            component: ProductCategories,
            children: [
                {
                    path: 'create',
                    name: routeNames.INVENTORY_PRODUCT_CATEGORY_CREATE,
                    meta: {title: 'Create Category'},
                    component: ManageProductCategory
                },
                {
                    path: ':productCategoryId',
                    name: routeNames.INVENTORY_PRODUCT_CATEGORY,
                    props: (route) => ({
                        productCategoryId: parseInt(route.params.productCategoryId)
                    }),
                    meta: {title: 'Category Details'},
                    component: ProductCategory
                },
                {
                    path: 'update/:productCategoryId',
                    name: routeNames.INVENTORY_PRODUCT_CATEGORY_UPDATE,
                    props: (route) => ({
                        productCategoryId: parseInt(route.params.productCategoryId)
                    }),
                    meta: {title: 'Update Category'},
                    component: ManageProductCategory
                },
                {
                    path: 'remove/:productCategoryId',
                    name: routeNames.INVENTORY_PRODUCT_CATEGORIES_REMOVE,
                    props: (route) => ({
                        productCategoryId: parseInt(route.params.productCategoryId)
                    }),
                    meta: {title: 'Remove Category'},
                    component: RemoveProductCategory
                }
            ]
        },
        {
            path: 'metric-types',
            name: routeNames.INVENTORY_METRIC_TYPES,
            props: true,
            meta: {title: 'Metric Types'},
            component: MetricTypes,
            children: [
                {
                    path: 'create',
                    name: routeNames.INVENTORY_METRIC_TYPE_CREATE,
                    meta: {title: 'Create Metric Type'},
                    component: ManageMetricType
                },
                {
                    path: ':metricTypeId',
                    name: routeNames.INVENTORY_METRIC_TYPE,
                    props: (route) => ({
                        metricTypeId: parseInt(route.params.metricTypeId)
                    }),
                    meta: {title: 'Metric Type Details'},
                    component: MetricType
                },
                {
                    path: 'update/:metricTypeId',
                    name: routeNames.INVENTORY_METRIC_TYPE_UPDATE,
                    props: (route) => ({
                        metricTypeId: parseInt(route.params.metricTypeId)
                    }),
                    meta: {title: 'Update Metric Type'},
                    component: ManageMetricType
                },
                {
                    path: 'remove/:metricTypeId',
                    name: routeNames.INVENTORY_METRIC_TYPES_REMOVE,
                    props: (route) => ({
                        metricTypeId: parseInt(route.params.metricTypeId)
                    }),
                    meta: {title: 'Remove Metric Type'},
                    component: RemoveMetricType
                }
            ]
        }
    ]
}
